
import { combineReducers } from 'redux';

// import * as fromTodos from './features/examples/redux/todos/state/reducers';
// import * as fromTodoCreate from './features/examples/redux/todos/containers/redux-todo-create/state/redux-todo-create.reducer';

export const initial_state = {
  // [fromTodos.todosStateKey]: undefined,
  // [fromTodos.todosVisibilityFilterStateKey]: undefined,
  // [fromTodoCreate.todoCreateStateKey]: undefined,

};

 export const rootReducer = combineReducers({
//   [fromTodos.todosStateKey]: fromTodos.todosReducer,
//   [fromTodos.todosVisibilityFilterStateKey]: fromTodos.visibilityFilterReducer,
//   [fromTodoCreate.todoCreateStateKey]: fromTodoCreate.todoCreateReducer,


 });




// WEBPACK FOOTER //
// ./client/app/store.rootReducer.js